export default __webpack_public_path__ + "403bcb1d2438740aaf7cf87737b8b63e.png";